import { useAuth } from '@hooks/auth';
import React from 'react';
import avatar0 from './assets/avatar0.jpg';
import avatar1 from './assets/avatar1.jpg';

import { Container } from './styles';

export const Profile: React.FC = () => {
  const { user } = useAuth();
  return (
    <Container>
      <img
        src={user?.gender === 'Masculino' ? avatar0 : avatar1}
        alt="avatar"
        height={32}
        width={32}
      />
      <p className="p2 ifpa-regular">{`${user?.name.split(' ')[0]}`}</p>
    </Container>
  );
};
